import '../../style/App.css';
import { useState, useRef, useEffect } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { backgroundImages } from '../../constants.js';
import FileUpload from '../FileUpload.js';
import TextInput from '../TextInput.js';
import GridMap from '../GridMap.js';
import { InfinitySpin } from 'react-loader-spinner';

import backgroundButton from "../../pics/icons/backgroundButton.png"
import OptionButton from './OptionButton';
import { useUser } from '../../../../../providers/UserProvider.js';


const ImagePopup = ({setPlayerViewBackground, setDefaultBackgroundOverride, encounterGuid, socket}) => {
    const [open, setOpen] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [uploadedLinks, setUploadedLinks] = useState([]);
    const [defaultOverride, setDefaultOverride] = useState(window.localStorage.getItem("defaultBackground") === "true");
 
    const [loading, setLoading] = useState(true);
    const { username } = useUser();

    const dialogRef = useRef(null);

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if ((dialogRef.current && !dialogRef.current.contains(event.target)) || event.target.tagName === 'IMG') {
                handleClose();
            }
        };

        if(open) {  
            if(uploadedFiles.length === 0 && uploadedLinks.length === 0) {
                socket.emit("getImages", "background", username);
                socket.on('sendImagesBackground', (backgrounds) => {
                    let images = [];
                    let links = [];
                    backgrounds.forEach(background => {
                        if(background.type === "link") {
                            // this is actually a youtube thumbs nail url
                            links.push(background) 
                        } else if (background.type === "background") {
                            images.push(background)
                        }
                    })
                    setUploadedLinks(links.reverse())
                    setUploadedFiles(images.reverse())
                        
                    setTimeout(()=> {
                        setLoading(false)
                    }, 500)
                });
            }
            document.addEventListener('mousedown', handleClickOutside)
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
       
        return () => { document.removeEventListener('mousedown', handleClickOutside); };
    }, [open]);

    const handleSetBackground = (type, src) => {
        setPlayerViewBackground({type: type, src: src})
    }

    const handleClick = (imageObj, isYoutubeLink) => {
        if(imageObj.imageGuid === 'constant') {
            socket.emit("encounterBackgroundChange", imageObj, encounterGuid)
        } else {
            // only send the guid when sending non constant files
            socket.emit("encounterBackgroundChange", {imageGuid: imageObj.imageGuid}, encounterGuid)
        }

        if (isYoutubeLink) { // i.e. https://www.youtube.com/watch?v=H-bd0eyF-HA&ab_channel=AnimatedBattleMaps
            const videoId = imageObj.image.split("vi/")[1].split('/max')[0];
            if (videoId) {
                let embedUrl = "https://www.youtube.com/embed/" + videoId

                const params = {
                    controls: 0,
                    mute: 1,
                    rel: 0,
                    autoplay: 1,
                    loop: 1,
                    playlist: videoId
                }

                // Mute by default and turn off controls so they dont show everytime on hover
                const queryParams = new URLSearchParams(params).toString();
                embedUrl += `?${queryParams}`;
                handleSetBackground("youtube", embedUrl)

            } else {
                console.error('Invalid YouTube URL');
                return;
            }
        } else {
            handleSetBackground("image", imageObj.image)
        }
    };

    const setDefaultBackground = (e) => {
        window.localStorage.setItem("defaultBackground", e.target.checked);
        setDefaultOverride(e.target.checked);
        setDefaultBackgroundOverride(e.target.checked);
    }

    return (
        <>
            <OptionButton src={backgroundButton} message={`Set Background${defaultOverride ? ': Default ON' : ''}`} onClickFunction={() => setOpen(true)} 
                imgStyle={{
                    outline: defaultOverride ? '1px solid rgba(100, 130, 125)' : '',
                    animation: defaultOverride ? 'defaultBackgroundShadowPulse 2.5s ease-in-out infinite' : ''
                }} 
            />
            <Dialog open={open} onClose={handleClose} ref={dialogRef} >
                {loading ? 
                    <InfinitySpin
                        visible={true}
                        width="200"
                        ariaLabel="infinity-spin-loading"
                    /> 
                    :
                    <DialogContent>
                        <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'center'}}>
                            <FileUpload setUploadedFiles={setUploadedFiles} storageKey={"background"} socket={socket} label={'Background'}/>
                            <TextInput setUploadedLinks={setUploadedLinks} socket={socket}/>
                        </div>
                        <hr className='lineSeperator' style={{margin: '10px 0 10px 0'}}/>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                            <i>DmView Background use Default</i>
                            <input type='checkbox' checked={defaultOverride} onChange={setDefaultBackground} 
                                style={{
                                    accentColor: '#575757ff',
                                    outline: defaultOverride ? '1px solid rgba(100, 130, 125)' : '',
                                    animation: defaultOverride ? 'defaultBackgroundShadowPulse 2.5s ease-in-out infinite' : ''
                                }}  
                            />
                        </div>
                        <hr className='lineSeperator' style={{margin: '10px 0 10px 0'}}/>
                        {uploadedLinks.length > 0 ? (
                            <>
                                <label htmlFor="grid" className='uploadedTitle'>Uploaded Youtube Links</label>
                                <hr/>
                                <GridMap imageArr={uploadedLinks} setImageArr={setUploadedLinks} handleClick={handleClick} isYoutubeLink={true} socket={socket}/>
                            </>
                        ) : (
                            <p>{'>'} No youtube links found</p>
                        )}
                        <hr className='lineSeperator' style={{margin: '10px 0 10px 0'}}/>
                        {uploadedFiles.length > 0 ? (
                            <>     
                                <label htmlFor="grid" className='uploadedTitle'>Uploaded Backgrounds</label>
                                <hr/>
                                <GridMap imageArr={uploadedFiles} setImageArr={setUploadedFiles} handleClick={handleClick} socket={socket}/>
                            </>
                        ) : (
                            <p>{'>'} No background images found</p>
                        )}
                        <hr className='lineSeperator' style={{margin: '10px 0 10px 0'}}/>
                        <label htmlFor="grid" className='uploadedTitle'>Default Backgrounds</label>
                        <hr/>
                        <GridMap imageArr={backgroundImages} handleClick={handleClick}/>
                    </DialogContent>
                }

            </Dialog>

        </>
    );
};

export default ImagePopup;